import { CLIENT_ID, CONSUMER_DETAILS, CREACTOR_DETAILS, GET_PERSONAL_DETAIL, HANDLE_IS_FIRST_TIME, HANDLE_PROFILE_DETAILS, IS_NEW_COMER, IS_VIEW_ABOUT_US, LINKED_PERSONAL_DATA, PRE_REGISTER, PROFILE_DETAILS, PROFILE_DETAILS_LOADING, REGISTER_DETAILS, TEST } from "./action_type";
import { defaultState } from "./initialState";

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case PRE_REGISTER:
            return {
                ...state,
                test: action.payload
            };
        case REGISTER_DETAILS:
            return {
                ...state,
                loginDetails: action.payload
            };

        case PROFILE_DETAILS:
            return {
                ...state,
                profileDetails: action.payload
            };
        case CLIENT_ID:
            return {
                ...state,
                clientID: action.payload
            };
        case CREACTOR_DETAILS:
            return {
                ...state,
                creatorDetails: action.payload
            };
        case PROFILE_DETAILS_LOADING:
            return {
                ...state,
                profileDetailsLoading: action.payload
            };
        case IS_VIEW_ABOUT_US:
            return {
                ...state,
                isViewAboutUs: action.payload
            };
        case HANDLE_PROFILE_DETAILS:
            return {
                ...state,
                handleProfileDetails: action.payload
            };
        case HANDLE_IS_FIRST_TIME:
            return {
                ...state,
                isFirstTime: action.payload
            };
        case CONSUMER_DETAILS:
            return {
                ...state,
                consumerDetails: action.payload
            };
        case IS_NEW_COMER:
            return {
                ...state,
                isNewComer: action.payload
            };
        case GET_PERSONAL_DETAIL:
            return {
                ...state,
                personalDetail: action.payload
            };
        case LINKED_PERSONAL_DATA:
            return {
                ...state,
                linkedPersonalDetails: action.payload
            }
        default:
            return state;
    }
};
export default reducer